import React, { useEffect, useState } from "react";
import { Table, Form, Button, Row, Col } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { FaTimes } from "react-icons/fa";

import { toast } from "react-toastify";
import Message from "../components/Message";
import Loader from "../components/Loader";
import { useProfileMutation } from "../slices/usersApiSlice";
import { useGetMyOrdersQuery } from "../slices/ordersApiSlice";
import { setCredentials } from "../slices/authSlice";

const ProfileScreen = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [phone, setPhone] = useState(""); 

  const { userInfo } = useSelector((state) => state.auth);

  const { data: orders, isLoading, error } = useGetMyOrdersQuery();

  const [updateProfile, { isLoading: loadingUpdateProfile }] =
    useProfileMutation();

  useEffect(() => {
    setName(userInfo.name);
    setEmail(userInfo.email);
    setPhone(userInfo.phone || "");
  }, [userInfo.email, userInfo.name, userInfo.phone]);

  const dispatch = useDispatch();
  const submitHandler = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      toast.error("סיסמאות לא תואמות");
    } else {
      try {
        const res = await updateProfile({
          _id: userInfo._id,
          name,
          email,
          password,
          phone
        }).unwrap();
        dispatch(setCredentials({ ...res }));
        toast.success("הפרופיל עודכן בהצלחה");
      } catch (err) {
        toast.error(err?.data?.message || err.error);
      }
    }
  };

  return (
    <Row>
      <Col md={9}>
        <h2 className="text-end">ההזמנות שלי</h2>
        {isLoading ? (
          <Loader />
        ) : error ? (
          <Message variant="danger">
            {error?.data?.message || error.error}
          </Message>
        ) : (
          <Table striped table hover responsive className="table-sm">
            <thead>
              <tr>
                <th></th>
                <th>נשלח</th>
                <th>שולם</th>
                <th>סה"כ</th>
                <th>תאריך</th>
                <th>מספר הזמנה</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order) => (
                <tr key={order._id}>
                  <td>
                    <LinkContainer to={`/order/${order._id}`}>
                      <Button className="btn-sm" variant="light">
                        פרטים
                      </Button>
                    </LinkContainer>
                  </td>
                  <td>
                    {order.isDelivered ? (
                      order.deliveredAt.substring(0, 10)
                    ) : (
                      <FaTimes style={{ color: "red" }} />
                    )}
                  </td>
                  <td>
                    {order.isPaid ? (
                      order.paidAt.substring(0, 10)
                    ) : (
                      <FaTimes style={{ color: "red" }} />
                    )}
                  </td>
                  <td>{order.totalPrice}</td>
                  <td>{order.createdAt.substring(0, 10)}</td>
                  <td>{order._id}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Col>
      <Col md={3}>
        <h2 className="text-end">פרופיל משתמש</h2>
        <Form onSubmit={submitHandler}>
          <Form.Group className="my-2" controlId="name">
            <Col xs={12} className="text-end">
              <Form.Label>שם</Form.Label>
            </Col>
            <Form.Control
              type="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              dir="rtl"
            ></Form.Control>
          </Form.Group>

          <Form.Group className="my-2" controlId="email">
            <Col xs={12} className="text-end">
              <Form.Label>מייל</Form.Label>
            </Col>
            <Form.Control
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              dir="rtl"
            ></Form.Control>
          </Form.Group>

          <Form.Group className="my-2" controlId="phone">
            <Col xs={12} className="text-end">
              <Form.Label>טלפון</Form.Label>
            </Col>
            <Form.Control
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              dir="rtl"
              placeholder="מספר טלפון"
            ></Form.Control>
          </Form.Group>

          <Form.Group className="my-2" controlId="password">
            <Col xs={12} className="text-end">
              <Form.Label>סיסמא</Form.Label>
            </Col>
            <Form.Control
              type="password"
              placeholder="הכנס סיסמא"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              dir="rtl"
            ></Form.Control>
          </Form.Group>

          <Form.Group className="my-2" controlId="confirmPassword">
            <Col xs={12} className="text-end">
              <Form.Label>אימות סיסמא</Form.Label>
            </Col>
            <Form.Control
              type="password"
              placeholder="אימות סיסמא"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              dir="rtl"
            ></Form.Control>
          </Form.Group>

          <Row className="my-2">
            <Col className="d-flex justify-content-end">
              <Button type="submit" variant="primary">
                עדכן
              </Button>
              {loadingUpdateProfile && <Loader />}
            </Col>
          </Row>
        </Form>
      </Col>
    </Row>
  );
};

export default ProfileScreen;
